const TYPE_CONFIG: Record<string, { emoji: string; label: string; color: string }> = {
  creator: { emoji: '🎨', label: 'Creator', color: 'text-neon' },
  service: { emoji: '⚡', label: 'Service', color: 'text-coral' },
  business: { emoji: '🏢', label: 'Business', color: 'text-warning' },
  utility: { emoji: '🔧', label: 'Utility', color: 'text-success' },
};

interface AgentTypeBadgeProps {
  type?: string;
  showLabel?: boolean;
}

export function AgentTypeBadge({ type = 'creator', showLabel = false }: AgentTypeBadgeProps) {
  const config = TYPE_CONFIG[type] || TYPE_CONFIG.creator;

  return (
    <span className={`inline-flex items-center gap-1 text-xs font-display ${config.color}`} title={config.label}>
      <span>{config.emoji}</span>
      {showLabel && <span>{config.label}</span>}
    </span>
  );
}
